import axios from 'axios';
import { Rendicontazione } from '../interface/rendicontazione';
import { TransactionData } from '../interface/transazioni';

export const fetchRendicontazioni = async (token: string, params?: URLSearchParams): Promise<Rendicontazione[]> => {
  const response = await axios.get<Rendicontazione[]>(`${process.env.REACT_APP_API_URL}/rendicontazioni/comitato`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchRendicontazione = async (token: string, id: string): Promise<Rendicontazione> => {
  const response = await axios.get<Rendicontazione>(`${process.env.REACT_APP_API_URL}/rendicontazioni/comitato/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchTransactionData = async (token: string, id: string): Promise<TransactionData> => {
  const response = await axios.get<TransactionData>(
    `${process.env.REACT_APP_API_URL}/rendicontazioni/comitato/${id}/transato`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
